// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__LtUBZ","header":"PatientQuestionnaire_header__N2Ai5","info":"PatientQuestionnaire_info__20P-p"};